export default {
    profileReferenceChart: {
        title: 'Fig A · Pojedinačni profili proizvoda',
        subtitle: 'Referenca — svaki profil prikazan zasebno',
        baseLabel: 'BASE (1.0 MW ravno)',
        peakLabel: 'PEAK (2.5 MW · 08:00–20:00)',
        offPeakLabel: 'OFF_PEAK (0.8 MW · bokovi)',
        ariaBase: 'BASE profil: ravno 1 MW kroz svih 96 petnaestominutnih intervala',
        ariaPeak: 'PEAK profil: 2.5 MW tijekom 08:00 do 20:00, nula izvan toga',
        ariaOffPeak:
            'OFF_PEAK profil: 0.8 MW tijekom 00:00–08:00 i 20:00–24:00, nula tijekom vršnog razdoblja',
    },
}
